import InfoButton from '../../../components/InfoButton/InfoButton'
import ComingSoon from '../../../components/ComingSoon/ComingSoon'
import '../Section.css'

function TheSoundtrack() {
  return (
    <div className="dashboard-section">
      <h1>
        The Soundtrack
        <InfoButton
          title="The Soundtrack"
          content={
            <div>
              <p>
                Pick songs for processional, recessional, first dance, parent dances, last song. 
                Share with your DJ/band so the soundtrack to your day is exactly what you want.
              </p>
              <p>
                <strong>Features:</strong>
              </p>
              <ul>
                <li>Organize songs by event (ceremony, reception, etc.)</li>
                <li>Create playlists for different moments</li>
                <li>Add must-play and do-not-play lists</li>
                <li>Share playlists with your DJ or band</li>
                <li>Link to Spotify, Apple Music, or YouTube</li>
              </ul>
              <p>
                The soundtrack to your day — exactly as you want it.
              </p>
            </div>
          }
        />
      </h1>
      <ComingSoon messageIndex={1} />
    </div>
  )
}

export default TheSoundtrack
